import React from "react";
import { Button } from "../../../components";
import CountdownTimer from "../../../components/CountdownTimer";
import { Chevron } from "../../../components/common/Icons";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphCountdownTimer.module.scss";

export interface ParagraphCountdownTimerProps {
	sectionHeading: string;
	countdownDate: string;
	linkUrl: string;
	linkTitle: string;
	text?: string;
}
export const getParagraphCountdownTimerProps = ({
	field_countdown_timer_title,
	field_countdown_timer_date,
	field_link,
	field_text,
}: Queries.ParagraphCountdownTimerDataFragment): ParagraphCountdownTimerProps => ({
	sectionHeading: field_countdown_timer_title,
	countdownDate: field_countdown_timer_date,
	linkUrl: field_link?.uri,
	linkTitle: field_link?.title,
	text: field_text?.value,
});

export const ParagraphCountdownTimer: React.FC<
	ParagraphCountdownTimerProps
> = ({ sectionHeading, countdownDate, linkUrl, linkTitle, text }) => {
	const newCountdownDate = new Date(countdownDate);
	return (
		<WrappedSection
			sectionColour={Colours.SANDY_FUR}
			sectionName="ParagraphCountdownTimer"
		>
			<div className={styles.paragraphCountdownTimer}>
				<header>
					<h2>{sectionHeading}</h2>
					{text && (
						<div
							className={styles.htmltext}
							// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
							dangerouslySetInnerHTML={{ __html: text }}
						/>
					)}
				</header>
				<CountdownTimer eventDate={newCountdownDate} />
				{linkUrl && linkTitle && (
					<Button url={linkUrl} variant="secondary" className={styles.cta}>
						{linkTitle}
						<Chevron
							rotation={90}
							width="20px"
							height="20px"
							fill={Colours.WHITE}
						/>
					</Button>
				)}
			</div>
		</WrappedSection>
	);
};

export default ParagraphCountdownTimer;
